<template>
    <div class="drawer fs-credit-drawer">
        <section class="content">
            <div class="row">
                <div class="col-xs-12">
                    <div class="box">
                        <div class="box-body">
                            <div class="container">
                                <PrivacyEN v-if="$i18n.locale == 'en'" />
                                <PrivacyTH v-else/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script>
import PrivacyTH from "./privacy/PrivacyTH";
import PrivacyEN from "./privacy/PrivacyEN";
export default {
    name: 'DrawerPolicy',
    props: {
        is_policy: {
            default: false
        }
    },
    components: {
        PrivacyTH,
        PrivacyEN
    },
    data() {
        return {
            is_open: true,
            cardDetail: null
        }
    },
    mounted() {
        this.$store.dispatch('getUserCardList')
    },
    methods: {
        toggle_credit_detail() {
            this.is_policy = !this.is_policy;
        },
        back_page(value) {
            if (value == 'delete') {
                this.$store.dispatch('getUserCardList')
                setTimeout(() => {
                    this.page = 1
                }, 1000)
            } else {
                this.page = 1
            }
        }
    },
    computed: {

    },
    watch: {
        is_open(value) {
            if (!value) {
                this.$emit('toggle_creditcard', true)
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/profile/PrivacyPolicy.vue